import React from "react";
import PropTypes from "prop-types";
import { Link } from "../Link";
import { validateNode } from "../helpers";
const NavigationMenu = ({ menu = [] }) => {
    return (React.createElement("nav", { role: "navigation" },
        React.createElement("ul", { className: "menu" }, menu.map((item, i) => {
            const { href, slug, title, to } = item;
            return React.createElement("li", { key: `automenu-${i}` }, validateNode(item, React.createElement(Link, { href: slug || href || to }, title)));
        }))));
};
NavigationMenu.propTypes = {
    menu: PropTypes.array.isRequired,
};
export default NavigationMenu;
export { NavigationMenu };
//# sourceMappingURL=index.js.map